import React from "react";
import { Link } from "react-router-dom";
import {
  HTMLSelect,
  Button,
  Intent,
  Spinner,
  NonIdealState,
} from "@blueprintjs/core";
import { parse as json2csv } from "json2csv";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

import "../assets/components/Feedback.css";

import Session from "../services/Session";
import { base } from "../fire";

class Attributes extends React.Component {
  constructor() {
    super();
    this.state = { session: null, instances: [], loading: true };
  }

  downloadToCSV = () => {
    const { session, instances } = this.state;
    const data = Session.getFeedbackAnswersForSession(session, instances);
    const formatedData = [];
    let element = document.createElement("a");
    let file = null;

    // Check if data exists and has content
    if (!data || data.length === 0) {
      console.warn("No feedback data available for export");
      return;
    }

    data.forEach((feedbackResult) => {
      if (feedbackResult.answers && feedbackResult.answers.length > 0) {
        feedbackResult.answers.forEach((answerData) =>
          formatedData.push({
            sessionName: session.metadata.name,
            participant: answerData.participantId,
            answer: answerData.answer,
            sessionShortname: session.metadata.shortname,
            sessionProtocol: session.metadata.protocol,
            sessionType: session.metadata.type,
            feedback: feedbackResult.feedback.question,
          })
        );
      }
    });

    // Check if we have any formatted data
    if (formatedData.length === 0) {
      console.warn("No feedback answers found to export");
      return;
    }

    file = new Blob([json2csv(formatedData)], { type: "text/csv" });
    element.href = URL.createObjectURL(file);
    element.download = `export_session_feedbacks_${session.id}`;
    element.click();
  };

  render() {
    const { instances = [], loading, session = {} } = this.state;
    // eslint-disable-next-line
    let answers = null;

    if (loading) return <Spinner className="margin-top-medium" />;
    if (session == null)
      return (
        <NonIdealState
          icon="thumbs-down"
          title="Session introuvable"
          description="Nous n'avons pas pu trouver la session."
          action={
            <Link to="/">
              <Button
                text="Liste des sessions"
                intent={Intent.PRIMARY}
                rightIcon="properties"
              />
            </Link>
          }
        />
      );
    if (!session.metadata.attributes || session.metadata.attributes === 0)
      return (
        <NonIdealState
          icon="circle"
          title="Aucun attributs configurés"
          description="Cette session ne semble pas avoir d'attributs configurés !"
          className="margin-top-medium"
        />
      );
    if (instances.length === 0)
      return (
        <NonIdealState
          icon="circle"
          title="Feedbacks indisponibles"
          description="Cette session semble ne pas diposer encore de feedbacks !"
          className="margin-top-medium"
        />
      );

    answers = Session.getFeedbackAnswersForSession(session, instances);
    return (
      <div className="row margin-top-medium">
        <div className="col-xs-12 text-right">
          <Button
            text="Exporter en CSV"
            style={{ marginBottom: "15px" }}
            onClick={this.downloadToCSV}
          />
        </div>
        <div className="col-xs-12">
          <FeedbackResultViewer
            session={session}
            attributes={session.metadata.attributes}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.sessionId = this.props.match.params.id;

    Session.getSessionById(this.sessionId).then((session) => {
      if (!session) return this.setState({ loading: false, session: null });
      this.setState({ session });
      this.syncSessionInstances = Session.syncSessionInstances(session.id, {
        context: this,
        state: "instances",
        asArray: true,
        then: () => this.setState({ loading: false }),
      });
    });
  }

  componentWillUnmount() {
    if (this.syncSessionInstances)
      base.removeBinding(this.syncSessionInstances);
  }
}

class FeedbackResultViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentAttribute: null };
  }

  handleChangeFeedback = (e) => {
    let resources =
      this.props.session.data.sequencesResources ||
      this.props.session.data.mcCriterias ||
      false;
    const value = e.target.value;
    const { attributes } = this.props;

    let index = attributes.findIndex((attribute) => attribute.id === value);
    let attributeQuantities = [];

    resources.forEach((resource, i) => {
      let quantity = resource.attributes[index].quantity;
      let name = resource.name;
      attributeQuantities.push({ name: name, quantity: parseInt(quantity) });
    });

    this.setState({
      currentAttributeId: attributes.find((attribute) => attribute.id === value)
        .id,
      attributeQuantities: attributeQuantities,
      currentAttribute: attributes.find((attribute) => attribute.id === value),
    });
  };

  render() {
    const { attributes = [] } = this.props;
    const { currentAttributeId } = this.state;
    const currentAttribute = attributes.find(
      (attribute) => attribute.id === currentAttributeId
    );

    if (currentAttributeId == null || currentAttribute == null)
      return <div className="feedback-wrapper" />;
    return (
      <div className="feedback-wrapper">
        <div className="row">
          <div className="col-xs-12 col-sm-4 col-md-3">
            <div className="infos">
              <div className="feedback-select">
                <HTMLSelect
                  onChange={this.handleChangeFeedback}
                  value={currentAttribute == null ? "" : currentAttribute.id}
                >
                  <option value="" disabled={true}>
                    Choisir un feedback...
                  </option>
                  {attributes.map((attribute, index) => (
                    <option key={index} value={attribute.id}>
                      {attribute.name}
                    </option>
                  ))}
                </HTMLSelect>
              </div>
              {/* <div className="question">
                                {currentAttribute.feedback.question}
                            </div> */}
            </div>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-9">
            <Attribute
              attributeQuantities={this.state.attributeQuantities}
              currentAttribute={this.state.currentAttribute}
              session={this.props.session}
            />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    let resources =
      this.props.session.data.sequencesResources ||
      this.props.session.data.mcCriterias ||
      false;
    const { attributes = [] } = this.props;

    let attributeQuantities = [];

    if (attributes.length && resources) {
      resources.forEach((resource, i) => {
        let quantity = resource.attributes[0].quantity;
        let name = resource.name;
        attributeQuantities.push({ name: name, quantity: parseInt(quantity) });
      });

      this.setState({
        currentAttributeId: attributes[0].id,
        attributeQuantities: attributeQuantities,
        currentAttribute: attributes[0],
      });
    }
  }
}

class Attribute extends React.Component {
  render() {
    let { attributeQuantities, currentAttribute } = this.props;

    attributeQuantities.sort(function (a, b) {
      return a.quantity > b.quantity ? 1 : b.quantity > a.quantity ? -1 : 0;
    });

    return (
      <div className="result">
        <div className="resume text-center">
          <div className="subtitle">Images attributes's values</div>
          <div>
            {currentAttribute.name} - {currentAttribute.unit}
          </div>
        </div>
        <div style={{ width: "100%", height: 500 }}>
          <ResponsiveContainer>
            <BarChart
              width={800}
              height={300}
              data={attributeQuantities}
              padding={{ bottom: 40 }}
              margin={{
                top: 30,
                right: 40,
                left: 40,
                bottom: 25,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis dataKey="quantity" />
              {/* <Tooltip /> */}
              <Bar dataKey="quantity" barSize={50} fill="blue" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default Attributes;
